import { render, staticRenderFns } from "./studentInfo.vue?vue&type=template&id=37f9328b&scoped=true&"
import script from "./studentInfo.vue?vue&type=script&lang=js&"
export * from "./studentInfo.vue?vue&type=script&lang=js&"
import style0 from "./studentInfo.vue?vue&type=style&index=0&id=37f9328b&prod&lang=less&scoped=true&"
import style1 from "./studentInfo.vue?vue&type=style&index=1&id=37f9328b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f9328b",
  null
  
)

export default component.exports